/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results == null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function isVariation() {
  var iation = getParameterByName("vn");

  return iation;
}

function isDev() {
  return window.location.href.toLowerCase().indexOf('assigntime') != -1;
}

function isStaging() {
  return window.location.href.toLowerCase().indexOf('staging') != -1;
}

function isProduction() {
  return !isDev() && !isStaging();
}

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
        if ($(window).width() < 600) {
          $('.fancybox').removeClass('fancybox');
          console.log("less than 600");
        }

        //$('.gifplayer').gifplayer();

        //Clicking on nav item will scroll user to section
        $(".nav li a[href^='#']").on('click', function (e) {
          // prevent default anchor click behavior
          e.preventDefault();
          // store hash
          var hash = this.hash;
          // animate
          $('html, body').animate({
            scrollTop: $(this.hash).offset().top
          }, 500, function () {
            window.location.hash = hash;
          });
        });

        //Clicking on nav item will scroll user to section
        $(".carrot-click a[href^='#']").on('click', function (e) {
          // prevent default anchor click behavior
          e.preventDefault();
          // store hash
          var hash = this.hash;
          // animate
          $('html, body').animate({
            scrollTop: $(this.hash).offset().top
          }, 500, function () {
            window.location.hash = hash;
          });
        });

        //Toggling between carousel will change person
        $("[data-target='#leaders']").click(function () {
          $("[data-target='#leaders']").removeClass("active");
          $(this).addClass("active");
        });

        //Afix sidebar when user scrolls past logos
        var waypoint = new Waypoint({
          element: document.getElementById('logos'),
          handler: function (direction) {
            $(".sidebar").toggleClass("fixed");
            $(".masthead").toggleClass("fixed");
          }
        });

        //open lightbox image
        $('.fancybox').fancybox({
          openEffect: 'none',
          closeEffect: 'none',
          iframe: {
            preload: false
          },
          padding: 0,
          margin: 5,
          height: 800,
          width: 1000
        });

        var videoPlayer = $('#bgndVideo');

        //Youtube API Key
        $.mbYTPlayer.apiKey = "AIzaSyB9x_Ey4UMSzyS7OhzJ0C-wrsxW7aKm9Eo";

        videoPlayer.YTPlayer();

        var playButtonClicked = false;
        var videoReadyToPlay = false;
        var startedProductVideo = false;

        function playProductVideo() {

          $('.site-wrapper').attr('style', 'background-color:rgba(0, 0, 0, 0)');

          // Make sure we don't try to play the video more than once at a time
          if (startedProductVideo === false) {
            startedProductVideo = true;

            videoPlayer.YTPChangeMovie({
              videoURL: 'https://www.youtube.com/watch?v=DpOpc5ZLYE0',
              containment: 'body',
              showControls: true,
              autoPlay: false,
              loop: false,
              vol: 50,
              mute: false,
              startAt: 0,
              opacity: 1,
              addRaster: false,
              quality: 'default',
              stopMovieOnBlur: false,
              optimizeDisplay: false
            });

            // remove text/buttons from on top of video
            $("#innerCover").hide();
            $(".mastfoot").hide();
            $("#controlBar_bgndVideo").show();
          }
        }

        function playVideo() {

          // Without this timeout, play doesn't actually play the video immediately after the onReady event
          setTimeout(function () {
            videoPlayer.YTPPlay();
          }, 100);
        }

        // Play button clicked  
        $('.play').on('click', function () {

          if (videoReadyToPlay) {
            playProductVideo();
          }

          playButtonClicked = true;
        });

        //Detect if we should start playing the video
        videoPlayer.on("YTPReady", function (e) {

          if (playButtonClicked) {
            playProductVideo();
          }

          playVideo();
          videoReadyToPlay = true;
        });

        // //When video ends show the hero container
        videoPlayer.on("YTPEnd", function (e) {
          startedProductVideo = false;

          $("#innerCover").show();
          $(".mastfoot").show();
          $("#controlBar_bgndVideo").hide();
          $(".home").addClass("finished");
        });

        //Typed.js type out the hero content
        $(".cover-heading").typed({
          strings: ["^1000 <strong>stressful...</strong> ^1000", "<strong>tiring...</strong> ^1000",
            "<strong>overwhelming</strong>.^1000<br/> The <strong>FOCUS Framework</strong> changes that."],
          typeSpeed: 50,
          contentType: 'html',
          startDelay: 10,
          backSpeed: 0
        });

        //Days left in campaign
        // $("#days-left").countdown("2016/06/04", function (event) {
        //   $(this).text(
        //     event.strftime('%D')
        //   );
        // });


        //fixing shitty css
        setInterval(function () {
          if ($(".navbar-collapse").hasClass("in")) {
            $("body.home .fixed").css({ 'overflow': 'visible' });
          } else {
            $("body.home .fixed").css({ 'overflow': 'scroll' });
          }
        }, 500);

        function discountProduct(productId, originalPrice) {
          $('#' + productId + ' p span').addClass("discounted-amount").before("<span class='discounted'>$" + originalPrice + "</span>");
        }

        // //Add discounted pricing
        // if (isProduction()) {
        //   discountProduct(31, 279);
        //   discountProduct(355, 299);
        //   discountProduct(361, 199);
        // }
        // else if (isDev()) {
        //   discountProduct(31, 279);
        //   discountProduct(49, 299);
        //   discountProduct(68, 199);
        // }
        // else {
        //   discountProduct(31, 279);
        //   discountProduct(66, 299);
        //   discountProduct(76, 199);
        // } 

        //Default product
        var defaultProductID = 31;

        function customizeVariation() {
          $('.product_list_widget li').hide();

            $('#packagesNoVideos').hide();

            $('#11261').show();
            $('#11240').show();
            $('#11241').show();
            $('#11239').show();

            discountProduct(11240, 799);

            defaultProductID = 11240;

          // if (isVariation() == "1") {
          //   $('#packagesNoVideos').hide();

          //   $('#11261').show();
          //   $('#11240').show();
          //   $('#11241').show();
          //   $('#11239').show();

          //   discountProduct(11240, 799);

          //   defaultProductID = 11240;
          // } 
          // else {
          //   $('#packages').hide();
          //   $('#videos').hide();
          //   $('#videosLink').hide();

          //   $('#8').show();
          //   $('#30').show();
          //   $('#31').show();

          //   discountProduct(31, 349);

          //   defaultProductID = 31;
          // }
        }

        customizeVariation();

        function addProductToCart(id) {
          var selectedProduct = $('*[data-product_id="' + id + '"]')[0];

          if (selectedProduct) {
            localStorage.setItem('product', id);
            $('*[data-product_id="' + id + '"]')[0].click();
            $('.sidebar-product').removeClass('clicked');
            $('#' + id + '').addClass('clicked');

            return true;
          }

          return false;
        }

        function goToCheckout() {
          // instant checkout page: workaround not being able to see the order button
          setTimeout(function () {
            // wait for the local storage changes to propigate
            window.location = "/checkout/";
          }, 500);
        }

        //Looking in local storage to see if a product exists, if not setting the default product and adding it to cart
        if (localStorage.getItem('product')) {
          if (!addProductToCart(localStorage.getItem('product'))) {
            addProductToCart(defaultProductID);
          }
        }
        else {
          addProductToCart(defaultProductID);
        }

        //When user clicks on a bundle update the cart add active state
        $('.sidebar-product').click(function () {
          var productId = $(this).attr('id');
          addProductToCart(productId);
          goToCheckout();
        });

        //When user clicks on a bundle update the cart add active state
        $('.ptp-button, #electronicOnlyBtn').click(function (event) {
          event.preventDefault();

          var productId = $(this).attr('href');
          addProductToCart(productId);
          goToCheckout();
        });

        //Sales widget in sidebar
        var sales = $('#total-sales > span').text();
        var salesNum = sales.replace(/[^\d.-]/g, '');
        var salesNumInt = parseInt(salesNum);
        var percentageTotal = (salesNumInt / 40000) * 100;
        $('.progress-bar').css('width', percentageTotal + '%').attr('aria-valuenow', percentageTotal);

        //Toggling classes based off of browser width for sidebar
        if ($(window).width() > 960) {
          $('.sidebar').toggleClass('show');
        } else {
          $('.sidebar').toggleClass('hidden');
        }

        //User can manually close the cart
        $('#display-cart').click(function () {
          $('.sidebar').removeClass('hidden');
          $('.sidebar').toggleClass('show');
          $(window).scrollTop($('#sidebar').offset().top);
        });
        $('.closeCart').click(function () {
          $('.sidebar').removeClass('show');
        });

        //Watching to see if the browser width changes then changing classes for sidebar
        $(window).resize(function () {
          if ($(window).width() > 960) {
            $('.sidebar').removeClass('hidden');
            $('.sidebar').addClass('show');
          } else {
            $('.sidebar').removeClass('show');
            $('.sidebar').addClass('hidden');
          }
        });

      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

(function ($) {
  var currentStep = -1;
  var previousLayout;

  function initInstructionDimensions() {
    const INSTRUCTION_RATIO = 0.8;
    $('.instructions > .content').css('max-height', $('.worksheet').height() * INSTRUCTION_RATIO);
  }

  function setStep() {
    var panel = $(".instruction-panel");
    var title = panel.find('.panel-title');
    var content = panel.find('.content');
    var step = $('.step:eq(' + currentStep + ')');
    var wrkshtImg = $('.worksheet img');
    var newLayout = step.attr('layout');
    var fields = step.find('.fields').children();

    panel.fadeOut("slow", function () {
      if (currentStep === 1 && !wrkshtImg.hasClass('fly-in')) {
        wrkshtImg.addClass('transitions');
        wrkshtImg.addClass('fly-in');
        setTimeout(setStep, 1500);
        return;
      }

      var changeImage = step.attr('changeImage');

      if (changeImage && wrkshtImg.attr('src') !== changeImage) {
        wrkshtImg.removeClass('transitions');
        $('.blank:visible').addClass('comeback').fadeOut("slow");
        wrkshtImg.fadeOut("slow", function () {
          wrkshtImg.attr('src', changeImage);
          wrkshtImg.fadeIn("slow");
          $('.comeback').fadeIn("slow").removeClass('comeback');
        });
        setTimeout(setStep, 1000);
        return;
      }

      title.html(step.find('.title').html() + " <span class='stepNumber'>" + (currentStep + 1) + ' of ' + $('.step').length + "</span>");
      content.html(step.find('.content').html());
      content.find('.lightboxable').attr('data-lightbox', 'step' + currentStep);

      if (newLayout !== previousLayout) {
        panel.addClass(newLayout);
        panel.removeClass(previousLayout);
        previousLayout = newLayout;
      }

      fields.each(function () {
        var field = $(this).attr("class");
        $('div.' + field).fadeIn("slow").get(0).focus();
      });

      if (fields.length > 0) {
        var firstField = fields.first().attr('class');
        $('div.' + firstField).get(0).focus();
      }

      if (currentStep === 0) {
        // first step
        $('.prev-button').hide();
        $('.next-button').text("Start");
      }
      else if (currentStep >= $('.step').length - 1) {
        // last step
        $('.next-button').hide();
      }
      else {
        // middle step
        $('.prev-button').show().text('Prev');
        $('.next-button').show().text('Next');
      }

      panel.fadeIn("slow");
    });
  }

  function nextStep() {
    currentStep++;
    setStep();
  }

  function prevStep() {
    currentStep--;
    setStep();
  }

  $(document).ready(function () {
    $('.prev-button').click(prevStep);
    $('.next-button').click(nextStep);
    $(window).resize(initInstructionDimensions);
  });

  $(window).load(function () {
    initInstructionDimensions();
    nextStep();
  });

  function swapImage(img) {
    var wrkshtImg = $('.worksheet img');
    wrkshtImg.attr('src', img);
  }
})(jQuery); // Fully reference jQuery after this point.